import { AchievementQualificationFunction } from '../types';

const SOLAR_PROJECT_TYPES: string[] = ['solar', 'consumerSolar'];

export const hasNoConsumptionData: AchievementQualificationFunction = ({ property }) => {
  return !property?.sundialSite?.dataSources?.some((source) => source?.sourceType === 'consumption');
};

export const hasNoActiveHvacProject: AchievementQualificationFunction = ({ user, featureFlags }) => {
  if (!featureFlags?.tasks) {
    return false;
  }
  return !user?.projects?.some((project) => project.type === 'hvac' && project.stage !== 'cancelled');
};

export const hasNoActiveEnergyBackupProject: AchievementQualificationFunction = ({ user, featureFlags }) => {
  if (!featureFlags?.tasks) {
    return false;
  }
  return !user?.projects?.some((project) => project.type === 'energyBackup' && project.stage !== 'cancelled');
};

export const hasNoSolarSystem: AchievementQualificationFunction = ({ user, property, featureFlags }) => {
  if (!featureFlags?.tasks) {
    return false;
  }
  const hasSolarProject = user?.projects?.some(
    (project) => SOLAR_PROJECT_TYPES.includes(project.type) && project.stage !== 'cancelled',
  );
  const hasNonArcadiaConsumption = property?.sundialSite?.dataSources?.some(
    (source) => source.sourceType === 'consumption' && source.sourceService !== 'arcadia',
  );
  return !hasSolarProject && !hasNonArcadiaConsumption;
};
